import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import { css } from 'styled-components';
export var FONT_VARIABLES = {
  PRIMARY: '--font-primary',
  SECONDARY: '--font-secondary'
};
export var baseFonts = /*#__PURE__*/css(["", ":Gothic A1,sans-serif;", ":Poppins,sans-serif;"], FONT_VARIABLES.PRIMARY, FONT_VARIABLES.SECONDARY);
export var FONTS = Object.keys(FONT_VARIABLES).reduce(function (acc, key) {
  return _extends({}, acc, _defineProperty({}, key, "font-family: var(".concat(FONT_VARIABLES[key], ");")));
}, {});